/**
 * 使用独立 axios 请求刷新令牌，避免经过 sysHttp 拦截器造成递归。
 * POST /auth/refresh-token，Header 可选携带当前 access token。
 */
import axios from 'axios';
import { sysApiBaseUrl } from '../config/env';
import type { ResultLoginRes } from './types/sysAuth';
import { clearSysTokens, getSysToken } from './sysAuthStorage';

const baseURL = sysApiBaseUrl;

export async function refreshAccessToken(
  refreshToken: string,
): Promise<ResultLoginRes> {
  const rt = getSysToken();
  if (!rt) {
    clearSysTokens();
    throw new Error('无刷新令牌');
  }
  const headers: Record<string, string> = {
    Authorization: `Bearer ${rt}`,
  };
  const url = `${String(baseURL).replace(/\/$/, '')}/auth/refresh-token`;
  const { data } = await axios.post<ResultLoginRes>(
    url,
    { refreshToken },
    { headers, timeout: 15000 }
  );
  return data;
}
